var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaulFooterLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 28,
    viewBox: "0 0 84 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6083 6.5116L54.6511 16.8551H59.0618L65.019 6.5116H71.6352L63.0343 21.4454H60.3684V21.4502H50.2841L50.2841 21.4454H45.3913L53.9922 6.5116H60.6083ZM82.662 6.5116L76.7048 16.8551H78.3834L75.737 21.4502L71.3694 21.4502L71.3694 21.4454H67.4449L76.0459 6.5116H82.662ZM83.945 11.9421V21.4454L81.4537 21.4454L81.4537 21.4502L78.4629 21.4502L81.1093 16.8551H81.1154L83.945 11.9421ZM16.501 6.5116L13.4135 11.8724H15.0992L12.6733 16.0845H10.9876L7.90005 21.4454H1.28403L9.88494 6.5116H16.501ZM38.5546 6.5116L38.5519 6.51636H42.9626L42.9654 6.5116H49.5815L40.9805 21.4454H34.367L39.1114 13.2078L39.1094 13.2067L40.3162 11.1114H35.9055L34.188 14.0933H35.8753L33.4494 18.3055H31.7621L29.9537 21.4454H23.3376L31.9386 6.5116H38.5546ZM27.5278 6.5116L18.9269 21.4454H12.3118L20.9127 6.5116H27.5278ZM5.47424 6.5116L0.000976562 16.0149V6.5116L5.47424 6.5116Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaulFooterLog);
export default __webpack_public_path__ + "static/media/haul-footer-log.4df4864f32f17f16a57ddd7b46a6a092.svg";
export { ForwardRef as ReactComponent };